{
  "pt": {
    "issue_category": {
      "labels": {
        "category_name": "Nome da categoria",
        "integration_warning": "Está ativa uma integração com o módulo Aftercare na sua plataforma. Se pretender criar ou editar categorias, contacte-nos.",
        "new_category": "Categoria"
      }
    }
  }
}